import LoadErrorMessage from './load-error-message';

export default LoadErrorMessage;
